var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramDesktopHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 20,
  viewBox: "0 0 23 20",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M5.991 0c4.833 0 4.967 2.5 5.668 2.5S11.571.03 16.424.03c3.457 0 5.958 4.57 5.97 6.063v1.309c0 2.7-1.626 4.601-3.906 6.62-.64.566-1.77 1.49-2.93 2.42l-.41.328c-1.774 1.418-3.489 2.755-3.489 2.755S5.89 15.588 4.156 14C1.97 11.993 0 10.083 0 7.384v-1.28C0 4.587 1.727 0 5.991 0m10.205.868c-3.82 0-3.843 3.307-4.472 3.307S10.307.895 5.97.895C2.143.896.972 4.986.972 6.287V7.91c0 2.313 1.487 3.62 3.45 5.338 1.555 1.363 7.302 5.204 7.302 5.204s1.371-1.106 2.861-2.318l.39-.318c1.11-.903 2.225-1.817 2.84-2.337 2.046-1.73 3.792-3.766 3.792-6.08V6.275c-.011-1.28-2.31-5.408-5.411-5.408"
})));
export default SvgInstagramDesktopHeart;